<div class="llm-models-modal">
    <nz-spin [nzSpinning]="loading" style="min-height: 200px;">
        <div class="info-section" *ngIf="!loading && modelData.providerName">
            <nz-descriptions [nzColumn]="1" [nzBordered]="true">
                <nz-descriptions-item nzTitle="Provider Name">{{modelData.providerName}}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="API Endpoint">{{modelData.apiEndpoint}}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="Documentation URL">
                    <a *ngIf="modelData.docUrl" [href]="modelData.docUrl" target="_blank">{{modelData.docUrl}}</a>
                    <span *ngIf="!modelData.docUrl">-</span>
                </nz-descriptions-item>
            </nz-descriptions>
        </div>

        <div class="model-selection-section" *ngIf="!loading && modelData.modelIds">
            <nz-divider nzText="Select Model" nzOrientation="left"></nz-divider>
            <nz-form-item>
                <nz-form-label nzFor="modelId" nzRequired>Model ID</nz-form-label>
                <nz-form-control>
                    <nz-select id="modelId" [(ngModel)]="selectedModelId" nzShowSearch
                        [nzPlaceHolder]="'Select a model'" [nzDisabled]="!modelData.modelIds || modelData.modelIds.length === 0">
                        <nz-option *ngFor="let modelId of modelData.modelIds; let i = index" [nzValue]="modelId"
                            [nzLabel]="modelId" [nzSelected]="i === 0 && selectedModelId === modelId">
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
    </nz-spin>

    <div class="modal-footer">
        <button nz-button nzType="default" (click)="close()">Cancel</button>
        <button nz-button nzType="primary" (click)="applyToLlmSetting()">Apply to LLM Setting</button>
    </div>
</div>